import { createElement } from 'react';
import { Modal as OriginalProModal } from 'antd';
import { BaseDialog } from '../../shared/base/BaseDialog';
export default class ProModal extends BaseDialog {
    render() {
        const innerProps = this.transformProps();
        return (createElement(OriginalProModal, { ...this.props, ...innerProps, onClose: innerProps.onCancel }));
    }
}
